import { useEffect, useState, useRef } from 'react';
import { getGalleryInfo } from '../../../../actions/gallery/galleryHeight';
import { LAYOUTS } from '../../../../constants/settingsConstants';
import { GALLERY_TYPES } from '../../../../constants/proGalleryConstants';

let interval;
const MAX_EVENTS = 10;
const ARROW_SELECTOR = 'button[data-hook="nav-arrow-next"]';

const useCreateThumbnails = (height) => {
  const eventCount = useRef(0);
  const isMultiplePlayed = useRef(false);
  const nextArrow = useRef(null);
  const [galleryRef, setGalleryRef] = useState(null);
  const [firstPGElement, setFirstPGElement] = useState(null);
  const [retryHandler, setRetryHandler] = useState(true);
  const [sliderClicks, setSliderClicks] = useState(0);
  const getGalleryRef = (ref) => setGalleryRef(ref);
  console.log(
    '==== Hook Started useCreateThumbnails hashtag data',
    height,
    sliderClicks
  );

  const { galleryLayout } = getGalleryInfo(GALLERY_TYPES.HASHTAG);
  const isSlider = galleryLayout === LAYOUTS.SLIDER;

  // Get gallery ref and check for video element, once got it update the state
  useEffect(() => {
    console.log('=== useEffect1', galleryRef);
    if (galleryRef) {
      // eventCount.current = 0;
      function checkForVideoElement(galleryRef) {
        console.log('Alternate checkForVideoElement');
        eventCount.current++;
        if (eventCount.current >= MAX_EVENTS) {
          clearInterval(interval);
        }
        // const firstVideo = galleryRef.querySelector('video');
        const firstElement = galleryRef.querySelector('.gallery-item-container');
        if (firstElement) {
          clearInterval(interval);
          setFirstPGElement(firstElement);
        }
      }

      interval = setInterval(() => checkForVideoElement(galleryRef), 1500);
    }
  }, [galleryRef]);

  // Dispatch a hover event on video element, then play the rest of the videos (on vid el \ height change)
  useEffect(() => {
    console.log('=== useEffect2', firstPGElement);
    if (firstPGElement) {
      isMultiplePlayed.current = false;
      function createThumbnailsFromVids() {
        console.log('createThumbnailsFromVids', eventCount.current);
        eventCount.current++;
        const videos = galleryRef.querySelectorAll('video');
        if (eventCount.current >= MAX_EVENTS) {
          // firstPGElement && hoverElement(firstPGElement);
          clearInterval(interval);
        }
        if (videos.length) {
          console.log('Running on', videos.length, 'c:', eventCount.current)
          videos.forEach((video) => {
            // console.log('Video Length', videos.length);
            if (video.currentTime > 0 && video.paused) return;
            video.play();
            setTimeout(() => {
              video.pause();
            }, 500);
          });
        }
        // If got multiple vids let it try 4 more times
        if (videos.length > 1 && !isMultiplePlayed.current) {
          isMultiplePlayed.current = true;
          eventCount.current = MAX_EVENTS - 3;
        }
      }

      function simulateMouseover() {
        console.log('Simulate Mouse Over', eventCount.current);
        hoverElement(firstPGElement);
        eventCount.current = 0;
        clearInterval(interval);
        interval = setInterval(createThumbnailsFromVids, 1500);
      }

      simulateMouseover();
    }
  }, [firstPGElement, height, sliderClicks]);

  // Add event listener to next arrow in case of slider
  useEffect(() => {
    const updateSliderClicks = () => setSliderClicks((clicks) => clicks + 1);
    if (isSlider && galleryRef) {
      setTimeout(() => {
        nextArrow.current = galleryRef.querySelector(ARROW_SELECTOR);
        console.log('Next arrow current', nextArrow.current);
        if (nextArrow.current) {
          nextArrow.current.addEventListener('click', updateSliderClicks);
        } else if(retryHandler) {
          // Retry if not loaded
          setRetryHandler(false);
        }
      }, 3000);
      return () => {
        nextArrow.current &&
          nextArrow.current.removeEventListener('click', updateSliderClicks);
      };
    }
  }, [galleryRef, retryHandler]);

  return getGalleryRef;
};

function hoverElement(element) {
  const event = new MouseEvent('mouseover', {
    view: window,
    bubbles: true,
    cancelable: true,
  });
  element.dispatchEvent(event);
}

export default useCreateThumbnails;
